import { render, staticRenderFns } from "./ChipsInput.vue?vue&type=template&id=39ce4b35&scoped=true&"
import script from "./ChipsInput.vue?vue&type=script&lang=js&"
export * from "./ChipsInput.vue?vue&type=script&lang=js&"
import style0 from "./ChipsInput.vue?vue&type=style&index=0&id=39ce4b35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce4b35",
  null
  
)

export default component.exports